import { render } from "./BannerContactos.vue?vue&type=template&id=796740ac&scoped=true"
import script from "./BannerContactos.vue?vue&type=script&lang=js"
export * from "./BannerContactos.vue?vue&type=script&lang=js"

import "./BannerContactos.vue?vue&type=style&index=0&id=796740ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796740ac"]])

export default __exports__